function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS LocationAddressField INSTEAD.
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { InputField, Icon } from '@unite-us/ui';
import places from "../../utils/places";
import { stringifyAddress, updateFieldsValues } from "./utils";
import isAddressValid from "./utils/isAddressValid";

/**
 * @visibleName LocationAddressField DEPRECATED
*/

/** Field keys expected by the LocationAddressField component. */
export var fieldNames = ['line_1', 'city', 'county', 'state', 'postal_code', 'country', 'latitude', 'longitude'];
function getCounty(place) {
  return place.address_components.find(function (component) {
    return component.types.includes('administrative_area_level_2');
  });
}
function getComputedProperty(obj, prop) {
  var value = obj[prop];
  if (typeof value === 'function') {
    value = value();
  }
  return value;
}

/**
 * Helper hook to setup the fields required by the LocationAddressField component.
 *
 * Only works with react-final-form.
 * You can pass the resulting object to the LocationAddressField component.
 *
 * Note: The useField hook is passed through dependency injection to avoid some
 * dependency issues with react-final-form.
 *
 * @param {Function} useField The useField hook from react-final-form.
 * @param {Object} [configs] An object with the field names as keys and the field configs as values.
 * @returns {Object} An object with the field names as keys and the field objects as values.
 */
export function useLocationAddressFields(useField) {
  var configs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.fromEntries(fieldNames.map(function (fn) {
    var config = configs[fn] || {};
    return [fn, useField(fn, config)];
  }));
}
var LocationAddressField = function LocationAddressField(props) {
  var cityRequiredMessage = props.cityRequiredMessage,
    className = props.className,
    coreApiClientBase = props.coreApiClientBase,
    dataTestId = props.dataTestId,
    fieldNamePath = props.fieldNamePath,
    google = props.google,
    id = props.id,
    initialTouched = props.initialTouched,
    label = props.label,
    placeholder = props.placeholder,
    required = props.required,
    requiredMessage = props.requiredMessage;
  var addressData = fieldNamePath ? props[fieldNamePath] : props;
  var invalidAddressMsg = cityRequiredMessage;
  var isValid = isAddressValid(addressData, required);
  var _useState = useState({
      name: id || 'pseudo-address',
      value: stringifyAddress(addressData),
      valid: isValid,
      invalid: !isValid,
      visited: false,
      active: false,
      touched: initialTouched,
      dirty: false,
      pristine: true,
      error: isValid ? undefined : invalidAddressMsg
    }),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  useEffect(function () {
    setAddress(_objectSpread(_objectSpread({}, address), {}, {
      value: stringifyAddress(addressData),
      valid: isValid,
      invalid: !isValid
    }));
  }, [addressData.line_1, addressData.city, addressData.county, addressData.country, addressData.postal_code, addressData.state]);
  var _useState3 = useState({
      open: false,
      results: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dropdown = _useState4[0],
    setDropdown = _useState4[1];
  var placesAdapters = {
    google: google,
    coreApiClientBase: coreApiClientBase
  };
  var autocomplete = function autocomplete(input) {
    return places.autocomplete(_objectSpread({
      input: input
    }, placesAdapters));
  };
  var debouncedAutocomplete = function debouncedAutocomplete(input) {
    return places.debouncedAutocomplete(_objectSpread({
      input: input
    }, placesAdapters));
  };
  var getPlaceDetails = function getPlaceDetails(placeId) {
    return places.getPlaceDetails(_objectSpread({
      placeId: placeId
    }, placesAdapters));
  };
  var onAddressChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var value, results;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            updateFieldsValues(null, addressData);
            value = event.target.value; // timeout set to push setAddress value AFTER useEffect hook triggered by updateFieldsValues
            setTimeout(function () {
              setAddress(_objectSpread(_objectSpread({}, address), {}, {
                value: value,
                valid: false,
                invalid: true,
                pristine: false,
                dirty: true,
                touched: true,
                error: invalidAddressMsg
              }));
            }, 0);
            _context.next = 5;
            return debouncedAutocomplete(value);
          case 5:
            results = _context.sent;
            setDropdown({
              open: true,
              results: results
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onAddressChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onAddressFocus = function onAddressFocus() {
    setAddress(_objectSpread(_objectSpread({}, address), {}, {
      active: true,
      touched: address.dirty
    }));
    if (dropdown.results.length !== 0) {
      setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
        open: true
      }));
    }
  };
  var onAddressBlur = function onAddressBlur(event) {
    setAddress(_objectSpread(_objectSpread(_objectSpread({}, address), !event.target.value ? {
      error: required ? requiredMessage : undefined,
      valid: !required,
      invalid: required
    } : {}), {}, {
      active: false,
      visited: true,
      touched: true,
      pristine: false
    }));
  };
  var onResultClick = function onResultClick(result) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var place, newResults, newDetailedPlaces, newCounty, location, resultObj;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getPlaceDetails(result.place_id);
          case 2:
            place = _context2.sent;
            if (getCounty(place)) {
              _context2.next = 18;
              break;
            }
            _context2.prev = 4;
            _context2.next = 7;
            return autocomplete(place.formatted_address);
          case 7:
            newResults = _context2.sent;
            _context2.next = 10;
            return Promise.all(newResults.map(function (newResult) {
              return getPlaceDetails(newResult.place_id);
            }));
          case 10:
            newDetailedPlaces = _context2.sent;
            newCounty = newDetailedPlaces.map(getCounty).find(function (county) {
              return county;
            });
            if (newCounty) {
              place = _objectSpread(_objectSpread({}, place), {}, {
                address_components: [].concat(_toConsumableArray(place.address_components), [newCounty])
              });
            }
            _context2.next = 18;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](4);
            // eslint-disable-next-line no-console
            console.error(_context2.t0);
          case 18:
            location = place.geometry.location;
            resultObj = _objectSpread(_objectSpread({}, result), {}, {
              result: _objectSpread({}, place),
              latLng: {
                lat: getComputedProperty(location, 'lat'),
                lng: getComputedProperty(location, 'lng')
              }
            });
            updateFieldsValues(resultObj, addressData);
            setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
              open: false
            }));
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 15]]);
    }));
  };
  var onResultKeyDown = function onResultKeyDown(result) {
    return function (event) {
      // Capture Enter and Space keys
      if (['Enter', ' '].includes(event.key)) {
        event.preventDefault();
        onResultClick(result)();
      }
    };
  };
  var onCloseDropDown = function onCloseDropDown() {
    setDropdown(_objectSpread(_objectSpread({}, dropdown), {}, {
      open: false
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "location-address-field ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "-address"),
    className: "location-address-field__address-field"
  }, /*#__PURE__*/React.createElement(InputField, _extends({
    id: "".concat(id, "-address-field"),
    label: label
  }, address, {
    onChange: onAddressChange,
    onFocus: onAddressFocus,
    onBlur: onAddressBlur,
    required: required,
    placeholder: placeholder,
    dataTestId: dataTestId
  })), dropdown.open && /*#__PURE__*/React.createElement("div", {
    className: "location-address-field__dropdown-close-btn"
  }, /*#__PURE__*/React.createElement(Icon, {
    id: "address-dropdown-close-btn",
    icon: "IconTimes",
    onClick: onCloseDropDown
  })), dropdown.open && /*#__PURE__*/React.createElement("div", {
    className: "location-address-field__dropdown"
  }, dropdown.results.map(function (result) {
    return /*#__PURE__*/React.createElement("div", {
      key: result.place_id,
      className: "location-address-field__dropdown-item",
      role: "button",
      onClick: onResultClick(result),
      onKeyDown: onResultKeyDown(result),
      tabIndex: "0"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "V2MapPin",
      color: "#4467AB"
    }), result.description);
  }), dropdown.results.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "location-address-field__dropdown-item location-address-field__dropdown-item--no-matches"
  }, "No matches found"))));
};
LocationAddressField.propTypes = {
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** className for reference */
  className: PropTypes.string,
  /** label text for button */
  label: PropTypes.string.isRequired,
  /** path to the address object from the Fields names */
  fieldNamePath: PropTypes.string,
  /** the google maps object */
  google: PropTypes.object.isRequired,
  /** pass required to InputField for address */
  required: PropTypes.bool,
  // Make zip code a required field.
  initialTouched: PropTypes.bool,
  cityRequiredMessage: PropTypes.string,
  requiredMessage: PropTypes.string,
  placeholder: PropTypes.string,
  dataTestId: PropTypes.string,
  coreApiClientBase: PropTypes.object
};
LocationAddressField.defaultProps = {
  className: '',
  fieldNamePath: 'address',
  required: true,
  initialTouched: false,
  cityRequiredMessage: 'City is required',
  requiredMessage: 'Required',
  placeholder: '',
  dataTestId: '',
  coreApiClientBase: null
};
export default LocationAddressField;